export const UploadSuccessIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
      <rect x="1" y="1" width="30" height="30" rx="15" fill="#007529" fillOpacity="0.2" />
      <rect x="1" y="1" width="30" height="30" rx="15" stroke="#007529" strokeWidth="2" />
      <path d="M9 17.3636L12.7333 21L23 11" stroke="#00F054" strokeWidth="2" strokeLinecap="round" />
    </svg>
  )
}
